module.exports = __webpack_public_path__ + "img/moniter-02@3x.11f7e57b.png";